export default __webpack_public_path__ + "static/media/feature2-1.2b717d63.png";